import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {HarponTile} from "./HarponTile";

// Constructor
export class HoleHarponTile extends HarponTile {

  constructor(rowIndex, colIndex) {
    super(rowIndex, colIndex);

    this.isValidMove = false;
    this.type = "hole";

    this.build();
  }

  build() {
    super.build();

    this.testedTile = new PIXI.Sprite(app.game.assets["tile-hole"]);
    this.testedTile.texture.source.resource.loop = true;
    this.testedTile.texture.source.resource.pause();
    this.testedTile.texture.source.resource.currentTime = 0;
    this.testedTile.position.set(28, 22);
    this.testedTile.scale.set(0.8);
    this.testedTile.alpha = 0;
    this.addChild(this.testedTile);
  }

  test() {
    this.testCounts++;

    if (this.testCounts >= 3) {
      this.show();
      app.audio.play(app.data.global.sounds.test_ice, 1.0, true);
      app.audio.play(app.data.global.sounds.ice_break, 1.0, true);
    } else {
      app.audio.play(app.data.global.sounds.test_ice, 1.0, true);
    }
  }

  show() {
    this.shown = true;
    this.testedTile.texture.source.resource.play();

    gsap.to(this.testedTile, {
      pixi: {
        alpha: 1
      },
      duration: 0.5,
      ease: "power1.inOut",
    })
  }

  hit() {
    if (!this.shown) {
      this.show();
      this.testCounts = 3; // max the test count directly because we went on it
      app.audio.play(app.data.global.sounds.ice_break_and_fall, 1.0, true);

      setTimeout(() => {
        app.audio.play(app.data.global.sounds.obstacle, 1.0, true);
      }, app.game.player.playerMovementDuration);
    } else {
      // Add a little delay because we trigger the hit as soon as we move
      setTimeout(() => {
        app.audio.play(app.data.global.sounds.obstacle, 1.0, true);
        app.audio.play(app.data.global.sounds.splash_water, 1.0, true);
      }, app.game.player.playerMovementDuration);
    }
  }

  endGame() {
    app.game.endGame();
    app.animateOutGame(9);
  }

  // Reset the states so we can animate in again and start over
  reset() {
  }


}
